import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  form: {
    display: "flex",
    alignItems: "center",
    marginTop: 10,
    flexDirection: "column",
    width: "100%",
  },
}));

export default useStyles;
